"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectLanguage = exports.initializeI18Next = exports.uuidV4 = exports.getServicesAxiosClient = exports.getAxiosInstance = exports.ProcessEnv = exports.getApiUrl = exports.sendAxiosPostRequest = exports.sendAxiosGetRequest = void 0;
const sendAxiosGetRequest_1 = __importDefault(require("./sendAxiosGetRequest"));
exports.sendAxiosGetRequest = sendAxiosGetRequest_1.default;
const sendAxiosPostRequest_1 = __importDefault(require("./sendAxiosPostRequest"));
exports.sendAxiosPostRequest = sendAxiosPostRequest_1.default;
const getApiUrl_1 = require("./getApiUrl");
Object.defineProperty(exports, "getApiUrl", { enumerable: true, get: function () { return getApiUrl_1.getApiUrl; } });
const processEnv_1 = __importDefault(require("./processEnv"));
exports.ProcessEnv = processEnv_1.default;
var axiosInstance_1 = require("./axiosInstance");
Object.defineProperty(exports, "getAxiosInstance", { enumerable: true, get: function () { return axiosInstance_1.getAxiosInstance; } });
Object.defineProperty(exports, "getServicesAxiosClient", { enumerable: true, get: function () { return axiosInstance_1.getServicesAxiosClient; } });
var uuidV4_1 = require("./uuidV4");
Object.defineProperty(exports, "uuidV4", { enumerable: true, get: function () { return uuidV4_1.uuidV4; } });
var initializeI18nNext_1 = require("./initializeI18nNext");
Object.defineProperty(exports, "initializeI18Next", { enumerable: true, get: function () { return initializeI18nNext_1.initializeI18Next; } });
var languageDetector_1 = require("./languageDetector");
Object.defineProperty(exports, "detectLanguage", { enumerable: true, get: function () { return languageDetector_1.detectLanguage; } });
